import request from "./request";
import apis from "./apis";

const {
  itemGroupInfo,
  allItemInfo,
  itemInfo,
  rentItem,
} = apis.rent;

const rentItems = {
  getAllItemGroupInfo: () => {
    return request.get(itemGroupInfo);
  },
  createItemGroupInfo: (data: Object) => {
    return request.post(itemGroupInfo, data);
  },
  updateItemGroupInfo: (data: Object) => {
    return request.put(itemGroupInfo, data);
  },
  deleteItemGroupInfo: (data: Object) => {
    return request.delete(itemGroupInfo, data);
  },
  getAllItemInfo: (data: Object) => {
    return request.get(allItemInfo, data);
  },
  createItemInfo: (data: Object) => {
    return request.post(itemInfo, data);
  },
  updateItemInfo: (data: Object) => {
    return request.put(itemInfo, data);
  },
  deleteItemInfo: (data: Object) => {
    return request.delete(itemInfo, data);
  },
  rentItem: (data: Object) => {
    return request.put(rentItem, data);
  },
};

export default rentItems;